let _ = require('lodash');

const licensePlateInput = document.querySelector('.kentekenplaat');

if (!_.isNil(licensePlateInput)) {
    new Kentekenplaat(licensePlateInput);
}